/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth__Forgot_Password__SubtitleInputs */

const en_auth__forgot_password__subtitle = /** @type {(inputs: Auth__Forgot_Password__SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You'll get a One Time Passcode in your email if it belongs to a valid account.`)
};

/**
* | output |
* | --- |
* | "You'll get a One Time Passcode in your email if it belongs to a valid account." |
*
* @param {Auth__Forgot_Password__SubtitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const auth__forgot_password__subtitle = /** @type {((inputs?: Auth__Forgot_Password__SubtitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth__Forgot_Password__SubtitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_auth__forgot_password__subtitle(inputs)
});